const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "")
const normalizeBaseUrl = (value = "") => (value.endsWith("/") ? value : `${value}/`)

const inferAccountUrl = () => {
  try {
    const current = new URL(window.location.origin)
    const parts = current.hostname.split(".")
    if (parts.length > 1) {
      parts[0] = "account"
      return `${current.protocol}//${parts.join(".")}${current.port ? `:${current.port}` : ""}`
    }
  } catch (error) {
    return window.location.origin
  }

  return window.location.origin
}

const readEnv = (value, fallback) => {
  if (typeof value !== "string") {
    return fallback
  }

  const trimmed = value.trim()
  return trimmed || fallback
}

export const runtimeConfig = {
  accountUrl: trimTrailingSlash(readEnv(process.env.REACT_APP_ACCOUNT_URL, inferAccountUrl())),
  apiBaseUrl: normalizeBaseUrl(readEnv(process.env.REACT_APP_API_URL, "/api/v1.0/"))
}

export const createAccountRedirectUrl = (path, redirectUrl = window.location.origin) => {
  return `${runtimeConfig.accountUrl}${path}?redirect=${encodeURIComponent(redirectUrl)}`
}
